export const BUILD_INFO = { 
  buildNumber: '1775667685853', 
  buildDate: '2026-04-08 17:01:25 UTC',
  gitBranch: 'main',
  gitCommitHash: '32408ff'
};
